import script from "./EditWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./EditWidget.vue?vue&type=script&setup=true&lang=js"

import "./EditWidget.vue?vue&type=style&index=0&id=3cd8cf0f&scoped=true&lang=css"
import "./EditWidget.vue?vue&type=style&index=1&id=3cd8cf0f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd8cf0f"]])

export default __exports__